import React, { ReactNode } from "react";
import { Radio,  RadioProps } from "@mui/material";
import { useTheme } from "@patron/utils/theme";
type CustomRadioComponentProps = RadioProps & {
  controldisabled?: boolean;
  children?: ReactNode;
  color?: string;
};



export const CustomRadioComponent = ({ controldisabled = false, ...props }: CustomRadioComponentProps) => {
  const theme = useTheme();
  return <Radio size="small" {...props} disableRipple={controldisabled} disabled={controldisabled} />;
};

export default CustomRadioComponent;
